"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageFooter = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var index_1 = require("../index");
require("./pageFooter.css");
var PageFooter = function (_a) {
    var children = _a.children, _b = _a.alignText, alignText = _b === void 0 ? 'left' : _b, _c = _a.topBorder, topBorder = _c === void 0 ? true : _c;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "page-footer ".concat(topBorder ? 'page-footer-border-top' : '') }, { children: (0, jsx_runtime_1.jsx)(index_1.TextFormatter, __assign({ textAlign: alignText, borderless: true }, { children: children })) })));
};
exports.PageFooter = PageFooter;
//# sourceMappingURL=PageFooter.js.map